import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { CartContext } from '../context/CartContext';
import {API_BASE} from '../config';
import '../css/imaging.css';

// --- DATA MAPPINGS FOR SLIDERS ---
const sliderBannerTemplates = {
  'mobility': [
    { id: 1, title: 'Samsung Galaxy Flip5', subtitle: 'Fresh design in an elegant case', bg: '#f3eade', img: 'https://th.bing.com/th/id/OIP.bVqQBJNQ9NCuzBA7kXwjBAHaHa?w=167&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3' }
  ],
  'ncn': [
    { id: 1, title: 'Enterprise IT Solutions', subtitle: 'Powerful Computing Platforms', bg: '#e2eff1', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8-s8GyqcZ5-7MscJrxw02yP_896pXXAC37kIfuY7cIg&s' }
  ],
  'imaging': [
    { id: 1, title: 'HP Smart Tank 580', subtitle: 'High-quality printing solutions', bg: '#f4eade', img: 'https://cdn.tgdd.vn/Products/Images/5693/311351/hp-smart-tank-580-wifi-1f3y2a-glr-1.jpg' }
  ],
  'refurbished': [
    { id: 1, title: 'Certified Refurbished Devices', subtitle: 'As good as new with warranty', bg: '#e8f4f8', img: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=300&auto=format&fit=crop' }
  ]
};

// --- DYNAMIC HOT CATEGORIES DATA MAPPING ---
const hotCategoriesTemplates = {
  'mobility': [
    { id: 1, name: 'Phones', icon: '📱' },
    { id: 2, name: 'Home Appliances', icon: '🧺' },
    { id: 3, name: 'Baby Care', icon: '🍼' },
    { id: 4, name: 'Skin Care', icon: '🧴' },
    { id: 5, name: 'Makeup', icon: '💄' }
  ],
  'ncn': [
    { id: 1, name: 'Computer / Laptop', icon: '💻' },
    { id: 2, name: 'Interactive Panels', icon: '🖥️' },
    { id: 3, name: 'Wi-Fi & Networking', icon: '📶' },
    { id: 4, name: 'CCTV & Surveillance', icon: '📹' },
    { id: 6, name: 'Biometric Attendance', icon: '🔐' },
    { id: 7, name: 'Servers & Storage', icon: '🖥️' }
  ],
  'imaging': [
    { id: 1, name: 'Cartridge', icon: '🎞️' },
    { id: 2, name: 'Toner', icon: '🎚️' },
    { id: 3, name: 'Ink', icon: '🧪' },
    { id: 4, name: 'Printers', icon: '🖨️' }
  ],
  'refurbished': [
    { id: 1, name: 'Refurbished Laptops', icon: '💻' },
    { id: 2, name: 'Refurbished Mobiles', icon: '📱' },
    { id: 3, name: 'Refurbished Printers', icon: '🖨️' },
    { id: 4, name: 'Certified Used Hardware', icon: '⚙️' }
  ]
};

// --- SAFE IMAGE CLEANING HELPER ---
const getCleanImage = (imgData) => {
  if (!imgData) return 'placeholder.jpg';
  if (Array.isArray(imgData)) return imgData[0] || 'placeholder.jpg';
  try {
    const parsed = JSON.parse(imgData);
    if (Array.isArray(parsed)) return parsed[0] || 'placeholder.jpg';
  } catch (e) {}
  
  if (typeof imgData === 'string' && imgData.includes(',')) {
    return imgData.split(',')[0].trim();
  }
  return String(imgData).replace(/[\[\]"]/g, "").trim() || 'placeholder.jpg';
};

// ==========================================
// 🧩 SUB-COMPONENTS
// ==========================================

const MainSlider = ({ data, currentSlide, setCurrentSlide }) => {
  if (!data || data.length === 0) return null;
  return (
    <div className="slider-main-container" style={{ backgroundColor: data[currentSlide]?.bg || '#f4eade' }}>
      <div className="slider-text-side">
        <span className="slider-mini-title">{data[currentSlide]?.subtitle}</span>
        <h2>{data[currentSlide]?.title}</h2>
        <button className="slider-buy-btn">Buy Now</button>
      </div>
      <div className="slider-img-side">
        <img src={data[currentSlide]?.img} alt="Promo item" />
      </div>
      <div className="slider-dots">
        {data.map((_, index) => (
          <span key={index} className={`dot ${currentSlide === index ? 'active' : ''}`} onClick={() => setCurrentSlide(index)}></span>
        ))}
      </div>
    </div>
  );
};

const SpecialOfferCard = () => (
  <div className="special-center-card">
    <div className="center-card-header"><span className="sub">Special Offer</span><h3>Washing Machine</h3><p>$799 Special Offer</p></div>
    <div className="center-card-image"><img src="https://www.bing.com/th/id/OIP.dp-nNvKXYs2hS0o2tcOkWAHaJF?w=193&h=237&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=ImgAns&rm=2" alt="Washing Machine" /></div>
  </div>
);

const HotCategories = ({ categories, selectedCategory, onCategoryClick }) => (
  <div className="hot-categories-panel">
    <h4>🔥 Hot categories</h4>
    <div className="circles-grid-layout">
      {categories.map(cat => (
        <div key={cat.id} className={`circle-item-node ${selectedCategory === cat.name ? 'active-category' : ''}`} onClick={() => onCategoryClick(cat.name)} style={{ cursor: 'pointer' }}>
          <div className="circle-avatar">{cat.icon}</div><span>{cat.name}</span>
        </div>
      ))}
    </div>
  </div>
);

const BestPicksShelf = ({ products, loading, onProductClick, selectedCategory }) => {
  const [showAll, setShowAll] = useState(false);
  const displayedProducts = showAll ? products : products.slice(0, 4);

  return (
    <div className="best-pick-section-bar">
      <div className="best-pick-header">
        <h3>Best pick {selectedCategory ? `in ${selectedCategory}` : 'of the week'}</h3>
        {products.length > 4 && (
          <span className="shop-more-anchor" onClick={() => setShowAll(!showAll)} style={{ cursor: 'pointer' }}>
            {showAll ? 'Show Less' : 'Shop More'}
          </span>
        )}
      </div>
      {loading ? ( 
        <p style={{ textAlign: 'center', padding: '20px' }}>Syncing Inventory Grid...</p> 
      ) : products.length === 0 ? ( 
        <p style={{ textAlign: 'center', padding: '20px' }}>No products found.</p> 
      ) : (
        <div className="horizontal-products-row-shelf">
          {displayedProducts.map(product => {
            const productId = product.id || product.Product_ID;
            return (
              <div key={productId} className="horizontal-product-micro-card" onClick={() => onProductClick(product)}>
                <div className="micro-img-wrapper">
                  <img src={getCleanImage(product.images || product.Images)} alt="Product" />
                </div>
                <div className="micro-details-column">
                  <h4>{product.title || product.Title}</h4>
                  <span className="micro-price-node">₹{product.price || product.Price}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const RecentlyViewedPanel = ({ recentProducts, onProductClick }) => {
  return (
    <div className="recently-viewed-sidebar">
      <div className="recent-products-box">
        <h3>Recently viewed</h3>
        <div className="recent-list-rows">
          {recentProducts.length === 0 ? (
            <p className="no-items-placeholder">No items viewed yet.</p>
          ) : (
            recentProducts.map(item => {
              const itemId = item.id || item.Product_ID;
              return (
                <div key={itemId} className="recent-micro-item" onClick={() => onProductClick(item)}>
                  <img src={getCleanImage(item.images || item.Images)} alt={item.title || item.Title} />
                  <div className="recent-txt-meta">
                    <h4>{item.title || item.Title}</h4>
                    <span className="recent-price">₹{item.price || item.Price}</span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div className="alby-promo-banner-card">
        <span className="brand-tag">Alby Urbanears</span>
        <h2>Get ready to impressive sound</h2>
        <div className="badge-pills-row">
          <span>🔋 Play Time 15 Hours</span>
          <span>⚡ ANC -48dB</span>
        </div>
        <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=300&auto=format&fit=crop" alt="promo headphones" className="banner-float-img" />
      </div>
    </div>
  );
};

const FeaturedProductsGrid = ({ products, loading, onProductClick, onAddToCart, activeTab, setActiveTab }) => {
  const tabs = ['Popular products', 'Most-viewed products', 'Top selling'];

  return (
    <div className="featured-main-grid-container">
      <div className="featured-header-tabs-row">
        <h3>Featured products</h3>
        <div className="tab-triggers-list">
          {tabs.map(tab => (
            <button key={tab} className={`tab-btn-node ${activeTab === tab ? 'active-tab' : ''}`} onClick={() => setActiveTab(tab)}>
              {tab}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', padding: '50px' }}>Loading Featured Items...</p>
      ) : products.length === 0 ? (
        <p style={{ textAlign: 'center', padding: '50px' }}>No featured products available.</p>
      ) : (
        <div className="products-matrix-layout-grid" style={{ maxHeight: '680px', overflowY: 'auto', paddingRight: '5px' }}>
          {products.map(product => {
            const productId = product.id || product.Product_ID;
            
            const hotVal = product.Hot_products || product.hot_products;
            const isHot = hotVal === 'Yes' || hotVal === true || hotVal === 1;

            return (
              <div key={productId} className="matrix-product-card-node" onClick={() => onProductClick(product)}>
                
                {isHot && <span className="card-hot-pill-label">HOT</span>}
                
                <div className="card-media-screen">
                  <img src={getCleanImage(product.images || product.Images)} alt={product.title || product.Title} />
                  <div className="hover-actions-overlay">
                    <button className="action-btn-cart-trigger" onClick={(e) => { e.stopPropagation(); onAddToCart(product); }}>
                      Add To Cart
                    </button>
                  </div>
                </div>

                <div className="card-body-meta-details">
                  <div className="color-swatch-circles-row">
                    <span className="swatch-dot color-one"></span>
                    <span className="swatch-dot color-two"></span>
                  </div>
                  
                  <h4 className="prod-title-heading">{product.title || product.Title}</h4>
                  <span className="sub-brand-category-label">{product.sub_category || product.Sub_Category || 'Category Node'}</span>
                  <div className="pricing-node-block">
                    <span className="retail-price-val">₹{product.price || product.Price}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ==========================================
// 🚀 MAIN EXPORT COMPONENT
// ==========================================
export default function DynamicProductPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const urlHeading = queryParams.get('heading') || 'mobility';
  const currentHeading = urlHeading.toLowerCase().trim();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeTab, setActiveTab] = useState('Popular products');
  
  // Real cart context hook
  const { addToCart } = useContext(CartContext);
  
  const [recentlyViewed, setRecentlyViewed] = useState(() => {
    const saved = localStorage.getItem('recently_viewed_products');
    return saved ? JSON.parse(saved) : [];
  });
  const [featuredTabProducts, setFeaturedTabProducts] = useState([]);

  const dynamicSliderData = sliderBannerTemplates[currentHeading] || sliderBannerTemplates['mobility'];
  const activeCategoriesList = hotCategoriesTemplates[currentHeading] || hotCategoriesTemplates['mobility'];

  useEffect(() => {
    setCurrentSlide(0);
    if (dynamicSliderData.length <= 1) return;
    const interval = setInterval(() => { setCurrentSlide(prev => (prev + 1) % dynamicSliderData.length); }, 4000);
    return () => clearInterval(interval);
  }, [currentHeading, dynamicSliderData.length]);

  // 🔄 Fetch products based on URL and selected category with Refurbished support
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    
    // Hamesha saare products fetch karenge taaki frontend unhein perfectly filter kar sake
    const apiUrl = `${API_BASE}/api/products`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        if (!isMounted) return;
        const parsedProducts = data.success ? data.data : (Array.isArray(data) ? data : []);
        let liveProducts = parsedProducts.filter(p => p.status !== 'Pending');

        // 1. Strict Vertical Filtering First (Database field check: vertical / Vertical / Megamenu Heading)
        liveProducts = liveProducts.filter(p => {
          const v = (p.vertical || p.Vertical || p.megamenu_heading || '').toLowerCase().trim();
          return v === currentHeading;
        });

        // 2. Flexible Sub-Category / Search Filter
        let filtered = liveProducts;
        if (selectedCategory) {
          const searchKey = selectedCategory.toLowerCase().trim();
          filtered = liveProducts.filter(p => {
            const subCat = (p.sub_category || p.Sub_Category || '').toLowerCase();
            const cat = (p.category || p.Category || '').toLowerCase();
            const title = (p.title || p.Title || '').toLowerCase();
            return subCat.includes(searchKey) || cat.includes(searchKey) || title.includes(searchKey);
          });
        }

        // 3. Best Offer Filter
        const bestOfferProducts = filtered.filter(p => {
          const offerVal = p.Best_Offer || p.best_offer;
          return offerVal === 'Yes' || offerVal === true;
        });

        // 4. Hot Products Filter
        const hotProductsList = filtered.filter(p => {
          const hotVal = p.Hot_products || p.hot_products;
          return hotVal === 'Yes' || hotVal === true || hotVal === 1;
        });

        // Fallback: Agar specific Best Offer ya Hot items empty hain toh filtered list dikhao
        setProducts(bestOfferProducts.length > 0 ? bestOfferProducts : filtered);
        setFeaturedTabProducts(hotProductsList.length > 0 ? hotProductsList : filtered);
        
        setLoading(false);
      })
      .catch((err) => {
        if (!isMounted) return;
        console.error("Failed syncing dynamic grid stream:", err);
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [currentHeading, selectedCategory]);

  const handleProductClick = (product) => {
    if (!product) return;
    const productId = product.id || product.Product_ID;
    if (!productId) return;

    const updatedHistory = [
      product,
      ...recentlyViewed.filter(p => (p.id || p.Product_ID) !== productId)
    ].slice(0, 3);

    setRecentlyViewed(updatedHistory);
    localStorage.setItem('recently_viewed_products', JSON.stringify(updatedHistory));
    
    navigate(`/product/${productId}`);
  };

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(prev => prev === categoryName ? null : categoryName);
  };

  return (
    <div className="layout-premium-wrapper" key={currentHeading}>
      
      {/* TOP GRID SECTION */}
      <div className="top-triple-grid">
        <MainSlider data={dynamicSliderData} currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
        <SpecialOfferCard />
        <HotCategories categories={activeCategoriesList} selectedCategory={selectedCategory} onCategoryClick={handleCategoryClick} />
      </div>

      {/* BEST PICKS ROW SECTION */}
      <BestPicksShelf 
        products={products} 
        loading={loading} 
        selectedCategory={selectedCategory} 
        onProductClick={handleProductClick}
      />

      {/* SPLIT LAYOUT BLOCK */}
      <div className="split-layout-featured-row-block">
        {/* Left Column Sidebar */}
        <RecentlyViewedPanel 
          recentProducts={recentlyViewed} 
          onProductClick={handleProductClick}
        />

        {/* Right Main Grid */}
        <FeaturedProductsGrid 
          products={featuredTabProducts} 
          loading={loading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onProductClick={handleProductClick}
          onAddToCart={handleAddToCart}
        />
      </div>

    </div>
  );
}